<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile)">
    <div v-if="!formProperty.readonly && !readOnly">
      <span class="text-grey-7">{{ getTitle() }}</span>
      <q-editor v-model="value" @update:model-value="onChange" debounce="500" :placeholder="formProperty.infoTextHint" :maxlength="formProperty.lengthMax" :autofocus="formProperty.autofocus"
                :error="propertyHasError" :error-message="getErrorLabel()" :id="formProperty.nativename" :ref="formProperty.nativename" :readonly="readOnly"
                :style="{ marginBottom: propertyHasError ? '0px' : '20px' }" @paste="onPaste"
                :definitions="{
                  movein: {
                    tip: $t('moveInTooltip'),
                    icon: 'arrow_right',
                    label: $t('moveIn'),
                    handler: moveIn
                  },
                  moveout: {
                    tip: $t('moveOutTooltip'),
                    icon: 'arrow_left',
                    label: $t('moveOut'),
                    handler: moveOut
                  }
                }"
                :toolbar="[
          ['left', 'center', 'right', 'justify'],
          ['bold', 'italic', 'strike', 'underline'],
          [
            {
              label: $q.lang.editor.formatting,
              icon: $q.iconSet.editor.formatting,
              list: 'no-icons',
              options: [
                'p',
                'h1',
                'h2',
                'h3',
                'h4',
                'h5',
                'h6',
                'code'
              ]
            },
            {
              label: $q.lang.editor.fontSize,
              icon: $q.iconSet.editor.fontSize,
              fixedLabel: true,
              fixedIcon: true,
              list: 'no-icons',
              options: [
                'size-1',
                'size-2',
                'size-3',
                'size-4',
                'size-5',
                'size-6',
                'size-7'
              ]
            },
            'removeFormat'
          ],
          ['unordered', 'ordered', 'indent', 'outdent'],
          ['movein', 'moveout']
        ]"
                :fonts="{
          arial: 'Arial',
          arial_black: 'Arial Black',
          comic_sans: 'Comic Sans MS',
          courier_new: 'Courier New',
          impact: 'Impact',
          lucida_grande: 'Lucida Grande',
          times_new_roman: 'Times New Roman',
          verdana: 'Verdana'
        }"/>
      <div v-if="propertyHasError" style="color: red; margin-left: 10px;" :style="{ fontSize: (volatile || compressed) ? '11px' : '12px', marginBottom: (volatile || compressed) ? '3px' : '2px' }">{{ getErrorLabel() }}</div>
    </div>

    <q-field v-else-if="formProperty.readonly && !readOnly" readonly="readonly" :label="getTitle()" stack-label :dense="volatile || compressed" borderless filled :error="propertyHasError"
             :error-message="formProperty.errorMsg" bg-color="grey-1" :class="formProperty.cssClass + ' txtMemoField'">
      <template v-slot:control>
        <div v-html="formatValue(formProperty)"/>
      </template>
    </q-field>

    <div v-else-if="readOnly" class="roRow">
      <span class="roLabel" v-html="getTitle() + ':'"></span>
      <span class="roValue" v-html="formatValue(formProperty)"></span>
    </div>
  </div>
</template>
<script>
import {getValueOrCleanNull} from './formsHelper'
import useVuelidate from '@vuelidate/core'
import {maxLength, minLength, requiredIf} from '@vuelidate/validators'
import {fldComponentsMixin} from './mixins/fldComponent'
import {StaticData} from '../../classes/StaticData'
import {setCssVar} from 'quasar'
import { useAuthStore } from 'src/stores/AuthStore.js'

export default {
  mixins: [fldComponentsMixin],
  props: [
    'queryID',
    'formProperty',
    'volatile',
    'compressed',
    'readOnly'
  ],
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      StaticData,
      value: this.getValue(),
      cssClass: "css" + this.formProperty.nativename
    }
  },
  computed: {
    propertyHasError() {
      return (this.v$.value.$error && !this.v$.$errors.map(err => err.$validator).includes('requiredIf')) || this.formProperty.invalid
    }
  },
  validations() {
    return this.getValidations()
  },

  methods: {
    formatValue(col) {
      let idx = 0
      let value = col.value

      // if we have a SQL error after fetchingData - there is no output of the value
      //logger.info("this.formProperty.errorFetchingData: ", this.formProperty.errorFetchingData);

      if (this.formProperty.errorFetchingData && this.formProperty.errorFetchingData != "") {
        value = ""
        console.error("Had errorFetchingData (", this.formProperty.errorFetchingData, "). Set value of ", this.formProperty.title, " to ''")
      } else if (value) {
        while ((idx = value.indexOf("gsm://")) > -1) {
          let telNr = ""
          let telIdx = idx + 6
          while ((!isNaN(parseInt(value.charAt(telIdx))) || value.charAt(telIdx) === ' ' || value.charAt(telIdx) === '/') && telIdx < value.length) {
            telNr += value.charAt(telIdx)
            telIdx++
          }
          value = value.replace("gsm://" + telNr, "<a href='tel:" + telNr + "'>" + telNr + "</a>")
        }

        if (col.datatypeID === StaticData.DATATYPES.TYPE_LINK) {
          value = "<a href='" + value + "' target='_blank'>" + value + "</a>"
        }

        if (col.datatypeID <= 5) {  // int,Long,Int64
          value = parseFloat(value).toLocaleString('de-DE', {})
        }
      }
      if (value == "null") value = ""
      return value;
    },

    moveIn() {
      const el = window.getSelection().focusNode.parentNode
      if (el.contentEditable == "true") {
        let margin = el.style.marginLeft
        let marginNr = 0
        if (margin != "") {
          margin = margin.replace("px", "")
          marginNr = parseInt(margin)
        }
        marginNr += 50
        el.style.marginLeft = marginNr + "px"
      }
    },

    moveOut() {
      const el = window.getSelection().focusNode.parentNode
      if (el.contentEditable == "true") {
        let margin = el.style.marginLeft
        let marginNr = 0
        if (margin != "") {
          margin = margin.replace("px", "")
          marginNr = parseInt(margin)
          if (marginNr > 0) {
            marginNr -= 50
            el.style.marginLeft = marginNr + "px"
          }
        }
      }
    },

    /**
     * Capture the <CTL-V> paste event, only allow plain-text, no images.
     * See: https://stackoverflow.com/a/28213320
     */
    onPaste(evt) {

      // logger.info("plaintext:", this.formProperty.richtTextPlaintextInsert)

      if (this.formProperty.richtTextPlaintextInsert) {
        // Let inputs do their thing, so we don't break pasting of links.
        if (evt.target.nodeName === 'INPUT') return
        let text, onPasteStripFormattingIEPaste
        evt.preventDefault()
        evt.stopPropagation()

        if (evt.originalEvent && evt.originalEvent.clipboardData.getData) {
          text = evt.originalEvent.clipboardData.getData('text/plain')
          this.$refs[this.formProperty.nativename].runCmd('insertText', text)
        } else if (evt.clipboardData && evt.clipboardData.getData) {
          text = evt.clipboardData.getData('text/plain')
          this.$refs[this.formProperty.nativename].runCmd('insertText', text)
        } else if (window.clipboardData && window.clipboardData.getData) {
          if (!onPasteStripFormattingIEPaste) {
            onPasteStripFormattingIEPaste = true
            this.$refs[this.formProperty.nativename].runCmd('ms-pasteTextOnly', text)
          }
          onPasteStripFormattingIEPaste = false
        }
      }
    },

    onChange(value) {
      if (typeof value === "string") {
        value = value.trim()
      }
      this.formProperty.invalid = false
      this.v$.$touch()
      if (value == "<br>" || value == "") {
        this.value = ""
        this.formProperty.value = null
      } else {
        this.value = value
        this.formProperty.value = value
      }
      this.setErrorBrandColor()

      // todo: only in formulars
      // send onChange event to parent (formular or parameter)
      if (!this.formProperty.noInitOnChange) {
        this.$emit('onChange', {classID: this.formProperty.classID, nativename: this.formProperty.nativename, deleteDependentFields: false, value: this.value})
      }
      if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
        this.eventBus.formularEdited()
      }
    },

    onRefreshComp(data) {
      if (this.formProperty.nativename == data.nativename && (data.subtypeCount == undefined || data.subtypeCount == this.formProperty.subtypeCount)) {

        if(data.isEventFromParameter && !this.formProperty.isParameter) return

        // only refresh if we have data and it is not a staticTextField without SQL (which never can change)
        if (data.value && data.value.length > 0) {

          let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''

          // this component instance is a dependent field of changed field?
          if (myDepToken.includes(data.sourceChangedNativename)) {
            //logger.info("string data.sourceChangedNativename:", this.formProperty.title, ", ", data.sourceChangedNativename, "==", myDepToken, ", value:", data.value)
            //logger.info("!!! onRefreshComp of ", this.formProperty.title + " triggered.", this.formProperty.nativename, data.value, data.value.length)
            this.value = data.value
            this.formProperty.value = data.value

            if (data.errorMsg) this.formProperty.errorMsg = data.errorMsg
            else this.formProperty.errorMsg = ""
            if (data.errorFetchingData) this.formProperty.errorFetchingData = data.errorFetchingData
            else this.formProperty.errorFetchingData = ""

            if (data.errorMsg || data.errorFetchingData) this.formProperty.invalid = true
            else this.formProperty.invalid = false

            this.$forceUpdate()

            if (this.formProperty.instantRefresh &&
                (this.formProperty.showThroughDependency == true || this.formProperty.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {

              //logger.info("cascade onChange ongoing from ", this.frmProperty.title)
              //logger.info("emit onchange for ", this.formProperty.nativename)
              this.$emit('onChange', {
                classID: this.formProperty.classID,
                id: this.formProperty.ID,
                nativename: this.formProperty.nativename, deleteDependentFields: true, value: this.value
              })  // send onChange event to parent (formular or parameter)

            } else {
              this.showSpinner = false
            }
          }
        }
      }
    },

    onClear(pevent) {
      if ((this.formProperty.nativename == pevent.nativename || pevent.nativename == "*") && (pevent.subtypeCount == undefined || pevent.subtypeCount == this.formProperty.subtypeCount)) {
        //logger.info("fldString - event onClearValueList: ", this.formProperty.nativename, ", resetValue:", pevent.resetValue)

        let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''
        //logger.info("onClearValueList with nativename ", this.formProperty.title, pevent.nativename, myDepToken, pevent.sourceChangedNativename, this.formProperty.valuelistType,this.formProperty.dataTypeID )
        //logger.info("onClearValueList:", this.formProperty.title, '(', this.formProperty.nativename, ') ', pevent.sourceChangedNativename, ', refreshToken=', this.refreshToken, '!=', pevent.guid)

        // this component instance is a dependent field of changed field? - clear this component instance an cascade the clear.
        if (myDepToken.includes(pevent.sourceChangedNativename)) {
          this.value = ""
          this.formProperty.value = ""
          // cascade clear event to other valuelists which are perhaps dependent on this
          // this.eventBus.clearValueListComp("*", "", this.formProperty.nativename, pevent.guid)
        }
      }
    },

    getValidations() {
      let result = {value: {}}
      if (!this.formProperty.readonly) {
        if (!this.formProperty.lengthMin) this.formProperty.lengthMin = 0
        result.value['minLength'] = minLength(this.formProperty.lengthMin)
        result.value['maxLength'] = maxLength(this.formProperty.lengthMax)
        result.value['requiredIf'] = requiredIf(() => {
          if (this.formProperty.masterPropertyMode == StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
            return (this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY) && this.formProperty.showThroughDependency == true
          } else {
            return this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY
          }
        })
        result.value['isValidGen'] = () => {  // generell invalid flag (triggered from extern)
          if (!this.formProperty.invalid) return true;
          return !this.formProperty.invalid
        }
      }
      return result
    },

    getErrorLabel() {
      let result = ""
      const errors = this.v$.$errors.map(err => err.$validator)
      if (errors.includes("requiredIf")) {
        result = this.formProperty.infoRequired && this.formProperty.infoRequired != "" ? this.formProperty.infoRequired : "Feld muss befüllt werden."
      } else if (errors.includes("minLength")) {
        const min = this.v$.$errors.find(err => err.$validator === "minLength").$params.min
        result = "Ungültige Länge, min: " + min
      } else if (errors.includes("maxLength")) {
        const max = this.v$.$errors.find(err => err.$validator === "maxLength").$params.max
        result = "Ungültige Länge, max: " + max
      } else if (errors.includes("isPatternMatch")) {
        result = "Ungültige Eingabe" //  Benötigtes Format: " + this.formProperty.regularExpression
      } else {
        result = this.formProperty.errorMsg
      }
      return result
    },

    // get current value of this string field
    // priority: 1-query parameter (deep link call), 2-local storage, 3-value, 4-default value
    getValue() {
      const authStore = useAuthStore()
      let result = this.formProperty.value // native value

      let propertyName = this.formProperty.name ? this.formProperty.name : this.formProperty.nativename
      let storedValue = localStorage.getItem(this.queryID + "__" + propertyName)
      let deepLinkParamValue = authStore.queryParamListFromDeepLink[this.formProperty.nativename]

      if (deepLinkParamValue) {
        // parameter value, given as request parameter (e.g.: qp.name), set in store in router beforeEach
        result = deepLinkParamValue
        this.formProperty.value = deepLinkParamValue
        //delete queryParamListFromDeepLink[this.formProperty.nativename] // delete after one use from store
      } else if (storedValue != null && !this.formProperty.systemParameter) {
        // use stored value in localstorage
        result = storedValue
        this.formProperty.value = getValueOrCleanNull(storedValue, this.formProperty)
      } else if (!this.formProperty.value && this.formProperty.defaultValue) {
        // use defaultValue of field
        result = this.formProperty.defaultValue
        this.formProperty.value = result
      }

      if (result === undefined || result === null) {
        result = ""
      }

      return result
    },

    setErrorBrandColor() {
      try {
        if (this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY) {
          setCssVar('negative', '#f57c00', document.getElementById('cont_' + this.formProperty.nativename))
        } else {
          setCssVar('negative', '#c10015', document.getElementById('cont_' + this.formProperty.nativename))
        }
      } catch (e) {
      }
    },

    onAutocompleteApplyButton(data) {
      if (this.formProperty.nativename == data.nativename && (data.subtypeCount == undefined || data.subtypeCount == this.formProperty.subtypeCount)) {
        this.value = data.value
        this.formProperty.value = data.value
        this.formProperty.errorMsg = ""
        this.formProperty.errorFetchingData = ""
        this.formProperty.invalid = false
        this.$forceUpdate()

        if (this.formProperty.instantRefresh && (this.formProperty.showThroughDependency == true || this.formProperty.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
          this.$emit('onChange', {
            classID: this.formProperty.classID,
            id: this.formProperty.ID,
            nativename: this.formProperty.nativename, deleteDependentFields: true, value: this.value
          })  // send onChange event to parent (formular or parameter)
        } else {
          this.showSpinner = false
        }
      }
    }
  },

  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshComp)
    this.eventBus.off('onClearValueList', this.onClear)
    this.eventBus.off('onAutocompleteApplyButton', this.onAutocompleteApplyButton)
  },

  mounted: function () {
    // set default validation values if nothing is set (e.g. resulset field update - no length can be set)
    if (!this.readOnly && this.$refs[this.formProperty.nativename]) {
      this.$refs[this.formProperty.nativename].runCmd('defaultParagraphSeparator', 'p')
    }

    if (!this.formProperty.lengthMin) this.formProperty.lengthMin = 0
    if (!this.formProperty.lengthMax) this.formProperty.lengthMax = 256

    this.eventBus.on('onRefreshComp', this.onRefreshComp)
    this.eventBus.on('onClearValueList', this.onClear)
    this.eventBus.on('onAutocompleteApplyButton', this.onAutocompleteApplyButton)

    this.formProperty.validate = () => {
      this.v$.$reset()
      this.v$.$touch()
      this.formProperty.invalid = this.v$.value.$error
      this.formProperty.errorMsg = this.getErrorLabel()
      this.setErrorBrandColor()

      if (this.formProperty.errorFetchingData != "") {
        this.formProperty.errorMsg = this.formProperty.errorFetchingData
        this.formProperty.invalid = true
      }
    }

    this.formProperty.setValid = () => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // bug? - rerender field & errorstats
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
      this.v$.$reset()
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // bug? - rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
      this.v$.$touch()
    }

    // Initial error? This can be if the field has SQL enabled content...
    if (this.formProperty.errorFetchingData && this.formProperty.errorFetchingData != "") {
      this.formProperty.setError(this.formProperty.errorFetchingData)
    }

    // send onChange event to parent (formular or parameter)
    if (this.formProperty.dataTypeID != StaticData.DATATYPES.TYPE_STATIC_TEXT && !this.formProperty.objInstanceID) {
      this.$emit('onChange', {classID: this.formProperty.classID, nativename: this.formProperty.nativename, deleteDependentFields: false, value: this.value})
    }
  }
}
</script>

<style lang="sass">
.r_field
  padding: 5px

  .r_title
    font-size: 12px
    display: block

  .r_error
    color: var(--q-color-negative)
    font-size: 12px
    line-height: 1

.ocrDlg
  height: 50%

  //.q-field--dense .q-field__label
  //  top: 6px

  .q-field--dense
    font-size: 13px

  .q-field--dense .q-field__bottom
    padding-top: 2px
</style>
